import { Route, Routes } from "react-router-dom";
import { RegistryChangeAlerts } from "@/features/registryChangeAlert/routes/RegistryChangeAlerts";

export const RegistryChangeAlertRoutes: React.FC = () => (
  <Routes>
    <Route path="" element={<RegistryChangeAlerts />} />
  </Routes>
);
